import React from "react";

const Input = ({ name, label, error, ...rest }) => {
  const { pattern, type, inputMode} = rest
  // console.log(pattern, type, inputMode)
  return (
    <div className="form-group">
      <label htmlFor={name}>{label}</label>
      <input {...rest} name={name} id={name} className="form-control" />
      {error && <div className="alert alert-danger">{error}</div>}
    </div>
  );
};

export default Input;
